import './styles.scss';

interface Props {
  className?: string;
}

export const VerticalDivider = ({ className = '' }: Props) => (
  <div className={`vertical-divider h-100 ${className}`}>&#8203;</div>
);
